import { createSlice } from "@reduxjs/toolkit";


const projectSlice = createSlice({
    name: 'project',
    initialState: {
        projectData:null
    },
    reducers: {
        setProjectData: (state, action) => {
            state.projectData = action.payload;
        },
    },
});

export const { setProjectData } = projectSlice.actions;

export default projectSlice.reducer;